import { Outlet } from "react-router-dom";
import Navbar from "../Components/Navbar";
import { Footer } from "../Components/Footer";
export default function Layout() {
    return (
        <div>
            {/* This is the main layout of the application */}
            {/* This is Navbar */}
            <Navbar />
            {/* This is where nested routes will be rendered */}
            <Outlet />
            {/* This is Footer */}
            <Footer />

        </div>
    );
}
